<template>
  <div class="function">
    <h1 class="function__title">{{ title }}</h1>
    <div class="function__grid" v-if="isText">
      <div
        v-for="(item, index) in fnData"
        :key="index"
        class="function__card"
        :style="{ animationDelay: index * 0.1 + 's' }"
      >
        <div class="function__card-image">
          <img :src="require(`../assets/img/${item.img}`)" alt="" />
          <div class="function__card-overlay"></div>
        </div>
        <div class="function__card-body">
          <h4 class="function__card-en">{{ item.english }}</h4>
          <h4 class="function__card-cn">{{ item.chinese }}</h4>
        </div>
      </div>
    </div>
    <div class="function__partners" v-else>
      <div
        v-for="(item, index) in fnData"
        :key="index"
        class="function__partner"
      >
        <img :src="require(`../assets/img/${item}`)" alt="" />
      </div>
    </div>
    <div class="function__more" v-if="more">
      <a href="javascript:;" @click="aaa">了解更多 &rarr;</a>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
  props: {
    title: {
      type: String,
      default: () => "",
    },
    fnData: {
      type: Array,
      default: () => [],
    },
    isText: {
      type: Boolean,
      default: () => false,
    },
    more: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const router = useRouter();
    const aaa = () => {
      router.push("/product");
    };
    return {
      aaa,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.function {
  width: $container-width;
  margin: 0 auto;
  padding: $space-xl 0;

  &__title {
    font-size: $font-size-hero-title;
    color: $color-text-primary;
    text-align: center;
    margin-bottom: $space-xl;
    position: relative;
    padding-bottom: $space-md;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0.6rem;
      height: 3px;
      background: $gradient-accent;
      border-radius: 2px;
    }
  }
}

// --- Tech Cards ---
.function__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: $space-lg;
}

.function__card {
  background: $color-bg-card;
  border-radius: $radius-md;
  overflow: hidden;
  box-shadow: $shadow-card;
  transition: box-shadow $transition-base, transform $transition-base;
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;

  &:hover {
    box-shadow: $shadow-card-hover;
    transform: translateY(-6px);

    .function__card-image img {
      transform: scale(1.08);
    }
  }
}

.function__card-image {
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 2rem;
    object-fit: cover;
    transition: transform $transition-slow;
  }
  .function__card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      transparent 50%,
      rgba($color-primary-dark, 0.6) 100%
    );
    pointer-events: none;
  }
}

.function__card-body {
  padding: $space-md;
  h4 {
    text-align: center;
    transition: color $transition-fast;
  }
  .function__card-en {
    font-size: $font-size-small;
    color: $color-primary;
    letter-spacing: 0.06em;
    font-weight: 600;
    margin-bottom: $space-xs;
  }
  .function__card-cn {
    font-size: $font-size-card-title;
    color: $color-text-primary;
    font-weight: 400;
  }
}

// --- Partner Logos ---
.function__partners {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: $space-lg;
}

.function__partner {
  width: calc(25% - $space-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $space-md;
  background: $color-bg-card;
  border-radius: $radius-sm;
  box-shadow: $shadow-sm;
  transition: box-shadow $transition-base, transform $transition-base;

  img {
    width: 1.5rem;
    height: auto;
    filter: grayscale(40%);
    opacity: 0.7;
    transition: all $transition-base;
  }

  &:hover {
    box-shadow: $shadow-md;
    transform: translateY(-2px);
    img {
      filter: grayscale(0%);
      opacity: 1;
    }
  }
}

// --- "More" link ---
.function__more {
  text-align: right;
  margin-top: $space-lg;
  a {
    color: $color-accent;
    font-size: $font-size-caption;
    font-weight: 500;
    text-decoration: none;
    transition: color $transition-fast;

    &:hover {
      color: #c56a00;
    }
  }
}

// --- Keyframes ---
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
